module.exports = __webpack_public_path__ + "img/whatsapp_logo.a148af2d.svg";